export const SUPPORTED_XL_CHART_TYPES = [
  "xlColumnClustered",
  "xlColumnStacked",
  "xlColumnStacked100",
  "xlBarClustered",
  "xlBarStacked",
  "xlBarStacked100",
  "xlLine",
  "xlLineMarkers",
  "xlLineStacked",
  "xlLineStackedMarkers",
  "xlPie",
  "xlPieExploded",
  "xlDoughnut",
  "xlDoughnutExploded",
  "xlArea",
  "xlAreaStacked",
  "xlAreaStacked100",
  "xlXYScatter",
  "xlXYScatterLines",
  "xlXYScatterLinesNoMarkers",
  "xlBubble",
  "xlBubble3DEffect",
  "xlRadar",
  "xlRadarFilled",
] as const;

export type XlChartType = (typeof SUPPORTED_XL_CHART_TYPES)[number];
